import _ from 'lodash'
import keyMirror from 'keymirror'

const TEAMS_CONSTANTS = keyMirror({
  FETCH_TEAMS_STARTED: null,
  FETCH_TEAMS_FINISHED: null,
  FETCH_TEAMS_FAILED: null,

  UPDATE_TEAM_STARTED: null,
  UPDATE_TEAM_FINISHED: null,
  UPDATE_TEAM_FAILED: null,
})

export const LOG_TEAM_STATEMENTS = [
  '.* updated. Open Hours: .* Timezone: .*',
  'User ID: .* Name: .* Email: .* Team .* created at .* on .*',
  'User ID: .* Name: .* Email: .* An update was made to .* at .* on .*',
  'User ID: .* Name: .* Email: .* .* .* .* at .* on .*',
  'User ID: .* Name: .* Email: .* .* .* at .* on .*'
]

export const LOG_PLAYBOOK_STATEMENTS = ['User ID: .* Name: .* Email: .* .* .* playbook .* at .* on .*']

export const LOG_WIDGET_STATEMENTS = ['Default Embed Configuration updated. .* changed to .*']

export const LOG_PASSWORD_STATEMENTS = ['Password Reset Event.*']

export default _.mapValues(TEAMS_CONSTANTS, _.uniqueId)



// WEBPACK FOOTER //
// ./src/scripts/constants/TeamsConstants.js